import { render, staticRenderFns } from "./reviewLinksChat.vue?vue&type=template&id=db14295e&"
import script from "./reviewLinksChat.vue?vue&type=script&lang=js&"
export * from "./reviewLinksChat.vue?vue&type=script&lang=js&"
import style0 from "./reviewLinksChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports